"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCode = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var oauth_1 = require("../../model/oauth");
var service_1 = require("../../../library/base/service");
var GetCode = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetCode, _super);
    function GetCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'oauth获取code';
        _this.code = '108001';
        _this.desc = 'oauth获取code';
        _this.requestParams = new oauth_1.GetCodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetCode;
}(service_1.BaseService));
exports.GetCode = GetCode;
//# sourceMappingURL=getCode.js.map